import { HttpParams, HttpHeaders } from '@angular/common/http';
import { LoginAccountResult } from 'src/app/Models/Account/login-account-result';
import Base from 'src/app/Models/Base/base';
import { AppStateService } from '../AppState/app-state.service';
import { ConstService } from '../Const/const.service';
import { CreateJumpAccountResult } from 'src/app/Models/Account/createJumpAccount-result';
import { catchError, tap } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { CompanyToken } from 'src/app/Models/Access/company-token-result';
import { getLocalStorage, setLocalStorage } from 'npx-arc-ui/utils';
import { GetUserResult, userDataObj } from 'src/app/Models/Account/getUserInfo-result';
import Rutas from 'src/app/Models/Base/rutas';
import { UserFromAccountResult } from 'src/app/Models/Account/user';
import Storage from 'src/app/Models/Base/storage';

export class AccountService {
  constructor(
    private appStateService: AppStateService) 
    {}

  /**
   * @description Permite crear una cuenta en el sistema
   * @param param0 Valores adjunto en FormGroup
   * @returns {Base}
   */
  AccountCreate({ value }: any) {
    let url = `${ConstService.URLApi}/Account/Create`;
    let token = this.appStateService.Access_Code;
    let params = new HttpParams()
      .set('AccessCode', token)
      .set('Email', value.email)
      .set('UserName', value.userName)
      .set('Password', value.password);

    this.appStateService.http.get<Base>(url, { params }).subscribe(
      (res) => {
        if (res.success) {
          //AUTH data!!
          const auth: string = JSON.stringify({
            relatedEmail: value.email,
            name: value.userName,
            access_code: this.appStateService.Access_Code,
          });
          this.appStateService.onPostLogin();
        } else {
          this.appStateService.showMiniMessage(res.message, 'error');
          return;
        }
      },
      (err) => {
        this.appStateService.showMiniMessage(
          'Ocurrio un error interno al intentar crear un usuario',
          'error'
        );
        return;
      }
    );
  }

  /**
   * @description Permite hacer login al portal, como proveedor. Indicando un email, contraseña y el rut de la empresa a la que se desea ingresar.
   * @param data Informacion obtenida del formulario **Login**
   * @returns {LoginAccountResult} LoginAccountResult
   */
  AccountLoginEmail({password, email}: any) {
    let encodePass: string = encodeURIComponent(password);
    
    let url = `${ConstService.URLApi}/Account/EmailLogin?Email=${email}&password=${encodePass}`;
    return this.appStateService.http.get<LoginAccountResult>(url)
  }

  public GetCheckAccount({ legalCode, name, email, password }: any) {
    let url = `${ConstService.URLApi}/Account/CheckAccount`;
    const params = new HttpParams()
      .set('legalCode', legalCode)
      .set('name', name)
      .set('email', email)
      .set('password', password);
    return this.appStateService.http.get<Base>(url, { params });
  }

  public PostCreateJumpAccount(payload: any) {
    let url = `${ConstService.URLApi}/Account/CreateJumpAccount`;
    return this.appStateService.http.post<CreateJumpAccountResult>(
      url,
      payload
    );
  }

  public CreateEnterprise(payload: any, token?: string) {
    this.appStateService.loading = true;
    let 
    url: string = `${ConstService.URLApi}/Account/AddCompanies`,
    headers = new HttpHeaders();

    if(token && !!token.length){
      headers = headers.append('Authorization', `Bearer ${token}`)
    }
    return this.appStateService.http.post<CompanyToken>(url, payload, { headers }).pipe(
      tap((res) => {
        this.appStateService.loading = false;
        if (res.success) {
          this.appStateService.showMiniMessage('Empresa asociada', 'success');
        } else {
          throw res.message;
        }
      }),
      catchError((err) => {
        this.appStateService.loading = false;
        this.appStateService.showMiniMessage(err, 'error');
        return throwError(err);
      })
    );
  }

  public UpdateCurrentUser(payload: userDataObj): void {
     
    this.appStateService.loading = true;
    var url: string = `${ConstService.URLApi}/Account/UpdateAccount`;
    this.appStateService.http.post<Base>(url, payload).subscribe((res: any) => {
      if (res.success) {
        this.appStateService.loading = false;
        this.appStateService.showMiniMessage('Proceso éxitoso', 'success');
      } else {
        this.appStateService.loading = false;
        this.appStateService.showMiniMessage(res.message, 'error');
      }
    });
  }

  GetDataUser(){
    let url = `${ConstService.URLApi}/Account/GetUserAccount`;
    return this.appStateService.http.get<GetUserResult>(url).pipe(
        tap(({success, message}) => {
        if(!success) {
          throw(message)
        }
      }),
      catchError((err) => {
        this.appStateService.showMiniMessage(
          'Error interno, por favor intentar más tarde.',
          'error'
        );
        return throwError(err)
      })
    )
  }

  public UpdateExpiredPassword(
    previousPassword: string,
    newPassword: string,
    token?: string
  ): void {
    this.appStateService.loading = true;
    const 
    url: string = `${ConstService.URLApi}/Account/UpdatePassword`,
    body = {
      previousPassword,
      newPassword,
      email: getLocalStorage('email')?.data || '',
    };
    let headers = new HttpHeaders();
    if(token && !!token.length){
      headers = headers.append('Authorization', `Bearer ${token}`)
    }
    this.appStateService.http.post<Base>(url, body, { headers })
    .subscribe(res => {
      if (res.success) {
        this.appStateService.dialog.closeAll();
        this.appStateService.loading = false;
        this.appStateService.showMiniMessage('Contraseña cambiada con éxito', 'success');
        this.appStateService.loginValues.email = getLocalStorage<string>(Storage.EMAIL)?.data || '';
        this.appStateService.loginValues.password = newPassword;

        const isDashboard = window.location.pathname.split('/')[1];
        if(!isDashboard.includes(Rutas.DASHBOARD)){
          this.appStateService.onLogin(this.appStateService.loginValues);
        }
      } else {
        this.appStateService.loading = false;
        this.appStateService.showMiniMessage(res.message, 'error');
      }
    });
  }

  GetCompanyToken(company: string, indicator?: number) {
    let url = `${ConstService.URLApi}/Account/CompanyToken`;
    let params = new HttpParams().set('CompanyID', company);
    this.appStateService.http.get<CompanyToken>(url, { params }).subscribe(
      (res) => {
        if (res.success) {
          setLocalStorage(Storage.TOKEN, res.token);
          if (indicator == 1) {
            window.location.reload();
          }
          else{
            this.appStateService.router.navigateByUrl(Rutas.DASHBOARD);
          }
        } else {
          this.appStateService.loading = false;
          this.appStateService.showMiniMessage(res.message, 'error');
        }
      },
      (err) => {
        this.appStateService.loading = false;
        this.appStateService.showMiniMessage(
          'Error interno, por favor intentar más tarde.',
          'error'
        );
      }
    );
  }

  public GetUsersFromAccount(itemsperpage: number = 5, page: number = 0) {
    let url = `${ConstService.URLApi}/Account/GetUsersFromAccount`;
    let params = new HttpParams()
      .set('itemsPerPage', itemsperpage.toString())
      .set('pageNumber', page.toString());

    return this.appStateService.http
      .get<UserFromAccountResult>(url, { params })
      .pipe(
        tap(({message, success}) => {
          if(!success){
            throw(message)
          }
        }),
        catchError((err) => {
          this.appStateService.showMiniMessage(
            err || 'Error interno, por favor intentar más tarde.',
            'error'
          );
          return throwError(err)
        })
      );
  }

  AccountLoginSupport({password, clientid,userid}: any) {
    let encodePass: string = encodeURIComponent(password);
    
    let url = `${ConstService.URLApi}/Account/LoginConsultoria?clientid=${clientid}&password=${encodePass}&userid=${userid}`;
    return this.appStateService.http.get<LoginAccountResult>(url)
  }

}
